import React from 'react';
import MainNavigation from '../components/layout/MainNavigation';
import Footer from '../components/layout/Footer';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white">
      <MainNavigation />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">Last updated: January 2025</p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Agreement to Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              By accessing or using TrainerLinked.in, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not access the platform.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">User Accounts</h2>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Registration</h3>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>You must provide accurate and complete information</li>
              <li>You are responsible for maintaining account security</li>
              <li>You must be at least 18 years old to use this platform</li>
              <li>One person or entity may not maintain multiple accounts</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-4">Account Responsibilities</h3>
            <p className="text-gray-700 leading-relaxed">
              You are responsible for all activities that occur under your account. Notify us immediately of any unauthorized use.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Platform Usage</h2>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Permitted Use</h3>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Connect trainers with organizations for legitimate training needs</li>
              <li>Manage training proposals, bookings, and contracts</li>
              <li>Share professional content and materials</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-4">Prohibited Activities</h3>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Posting false or misleading information</li>
              <li>Impersonating others or providing false credentials</li>
              <li>Harassing or discriminating against other users</li>
              <li>Attempting to circumvent platform fees</li>
              <li>Scraping or automated data collection</li>
              <li>Uploading malicious code or viruses</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Trainer Obligations</h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Maintain accurate professional credentials and certifications</li>
              <li>Deliver services as agreed in contracts</li>
              <li>Maintain professional conduct with organizations</li>
              <li>Comply with all applicable laws and regulations</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Organization Obligations</h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-2">
              <li>Provide accurate training requirements</li>
              <li>Honor contracts and payment terms</li>
              <li>Treat trainers with respect and professionalism</li>
              <li>Provide necessary facilities and resources for training</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Payments and Fees</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Platform fees and payment terms will be communicated separately. All fees are non-refundable unless otherwise stated.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Intellectual Property</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              The platform and its content are owned by TrainerLinked.in. Users retain ownership of their uploaded content but grant us a license to use it for platform operations.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Disputes</h2>
            <p className="text-gray-700 leading-relaxed">
              We encourage users to resolve disputes directly. TrainerLinked.in may assist in mediation but is not responsible for disputes between trainers and organizations.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Limitation of Liability</h2>
            <p className="text-gray-700 leading-relaxed">
              TrainerLinked.in is provided "as is" without warranties. We are not liable for indirect, incidental, or consequential damages arising from platform use.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Termination</h2>
            <p className="text-gray-700 leading-relaxed">
              We may terminate or suspend access to our platform immediately, without prior notice, for any breach of these Terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Changes to Terms</h2>
            <p className="text-gray-700 leading-relaxed">
              We reserve the right to modify these terms at any time. Continued use of the platform after changes constitutes acceptance of new terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Governing Law</h2>
            <p className="text-gray-700 leading-relaxed">
              These Terms are governed by the laws of India. Disputes shall be subject to the exclusive jurisdiction of courts in India.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Information</h2>
            <p className="text-gray-700 leading-relaxed">
              For questions about these Terms, contact us at:
            </p>
            <p className="text-blue-600 mt-2">contact@trainerlinked.in</p>
          </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default TermsOfService;
